import { Pipe, PipeTransform } from '@angular/core';
import { OrdersListDto } from 'src/generated_client';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  transform(order: OrdersListDto[], text: string): any[] {

    if (text === '') 
      return order

    text = text.toLocaleLowerCase()

    return order.filter(i => {

      if (i.dsUserName.toLocaleLowerCase().indexOf(text) >= 0)
        return true

      if (i.cdOrder.toString().indexOf(text) >= 0)
        return true
    })
  }
}


